import { t } from '@framework/i18n/intl/i18next.ts';
import { Space } from 'antd';
import { type CardTabListType } from 'antd/es/card';
import { UnreadCommunicationsBadge } from './UnreadCommunicationsBadge.tsx';

interface SubmissionSentTabListOptions {
  shouldShowCommunicationsTab: boolean;
  shouldShowIntegrationsTab: boolean;
  shouldShowPaymentsTab: boolean;
  submissionId?: string | null;
}

export const getSubmissionSentTabList = (
  options: SubmissionSentTabListOptions,
) => {
  const {
    shouldShowCommunicationsTab,
    shouldShowIntegrationsTab,
    shouldShowPaymentsTab,
    submissionId,
  } = options;

  return [
    {
      key: 'receipt',
      tab: t('submission-details.ricevuta-invio', 'Ricevuta invio'),
    },
    {
      key: 'request',
      tab: t('submission-details.la-mia-richiesta', 'La mia richiesta'),
    },
    ...(shouldShowCommunicationsTab
      ? [
          {
            key: 'communications',
            tab: (
              <Space size={4}>
                {t('submission-details.comunicazioni', 'Comunicazioni')}
                <UnreadCommunicationsBadge submissionId={submissionId} />
              </Space>
            ),
          },
        ]
      : []),
    ...(shouldShowIntegrationsTab
      ? [
          {
            key: 'integrations',
            tab: t('submission-details.integrazioni', 'Integrazioni'),
          },
        ]
      : []),
    ...(shouldShowPaymentsTab
      ? [
          {
            key: 'payments',
            tab: t('submission-details.pagamenti', 'Pagamenti'),
          },
        ]
      : []),
  ] as CardTabListType[];
};
